import './OldCarouselDotsStyles.css';
export var stylesOldCarousel = "s1524jdk";